import { useContext } from 'react';
import { RestClientsContext } from '../../contexts/RestClients/RestClientsContext';
import { ai } from '@sekoia/shared/utils/telemetryService';

export const useTasksClient = () => {
  const { tasks } = useContext(RestClientsContext);

  if (!tasks) {
    ai.trackException(`No Tasks client found, did you forget to wrap the application with a <RestClientsProvider />?`);
    throw new Error(`No Tasks client found, did you forget to wrap the application with '<RestClientsProvider />?`);
  }

  return tasks;
};
